import React from 'react';
import './App.css';

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from './Pages/Home/Home';
import AddNew from './Pages/AddNew/AddNew';
import EditTask from './Pages/EditTask/EditTask';
import NavBar from './Components/NavBar/NavBar';
function App() {
  return (
    <div className="">
      <Router>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/addNew" element={<AddNew />} />
          <Route path="/editTask/:id" element={<EditTask />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
